import {IConfigurationEvaluationContext} from '../configuration-evaluation-context/configuration-evaluation-context.interface';
import {IPropertyEvaluator} from '../property-evaluator/property-evaluator.interface';
import {Check} from '@sparkware/app-utils';

export class PropertiesEvaluator {
  constructor(private _propertiesEvaluators: IPropertyEvaluator[]) {
  }

  private _config: unknown = null;

  evaluate(context: IConfigurationEvaluationContext): any {
    if(Check.isNullOrUndefined(this._config)) {
      let config = {};

      this._propertiesEvaluators.forEach(propEvaluator => {
        Object.defineProperty(config, propEvaluator.propertyName, {
          get: () => propEvaluator.evaluate(context),
          configurable: false,
          enumerable: true
        });
      });

      this._config = config;
    }

    return this._config;
  }

  static fromRoot(rootObject: object, context: IConfigurationEvaluationContext): PropertiesEvaluator {
    let rootProps = Object.keys(rootObject).map(propName => context.createPropertyEvaluator(propName, rootObject));
    return new PropertiesEvaluator(rootProps);
  }
}
